import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import AuditLogPage from './AuditLogPage';
import CommerceLogPage from './CommerceLogPage';

const LogPage: FC = () => {
  return (
    <Routes>
      <Route path='/commerce' element={<CommerceLogPage title='앱 로그' />} />
      <Route path='/audit' element={<AuditLogPage title='감사 로그' />} />
      <Route path='/' element={<Navigate to='/audit' />} />
    </Routes>
  );
};

export default LogPage;
